import { render } from "./BreadCrumb.vue?vue&type=template&id=4a125824&ts=true"
import script from "./BreadCrumb.vue?vue&type=script&lang=ts"
export * from "./BreadCrumb.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__